import { create } from 'zustand'

const initialValue = {
  scrollYMap: {},
  latestScrollY: 0
}
export const useScrollStore = create((set, get) => ({
  ...initialValue,
  setLatestScrollY: (y) => set({ latestScrollY: y }),
  saveScrollY: (key) =>
    set((state) => ({
      scrollYMap: {
        ...state.scrollYMap,
        [key]:
          state.latestScrollY ||
          window.scrollY ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0
      }
    })),

  getScrollY: (key) => get().scrollYMap[key] ?? 0,
  clearScrollY: (key) =>
    set((state) => {
      const updated = { ...state.scrollYMap }
      delete updated[key]
      return { scrollYMap: updated }
    })
}))
